
export const environment: any = {
  name: 'production',
  production: true,
  authClientId: 'sci-chat',
  apiUrl: 'https://app.safe-checkin.com/api',
  loginUrl: 'https://login.safe-checkin.com/api',
  editUserUrl: 'https://login.safe-checkin.com/user/edit-user',
  adminUrl: 'https://app.safe-checkin.com/admin',

  translationApiUrl: 'https://app.safe-checkin.com/api',
  hereMapApiKey: 'c4epBeb8cdyYxTz3IXQBaSWUD9VgvDzW0MB8Vyi6pkk',

  cometAppID: '182578381ca28fc',
  cometApiKey: '625d5f418e5906346e4c0eaf7072f0b03a06b848',

  signalr: 'https://app.safe-checkin.com/signalr/hubs/safecheckin',

  webVersion: 'https://app.safe-checkin.com/assets/version.json',

  appStoreUrl: 'https://itunes.apple.com/us/app/apple-store/id1579161607',
  androidMarketUrl: 'http://play.google.com/store/apps/details?id=com.cargoclix.safe.checkin',

  identityConfig: {
    identityEndpoint: 'https://login.safe-checkin.com/',
    clientId: 'sci-chat',
    hostUrl: 'https://app.safe-checkin.com/',
    deviceHostUrl: 'sci://sci.safe-checkin.com/',
    requiredScopes: 'openid profile ccx.profile sci.chat.api sci.backend.api ccx.identity.api offline_access',
    responseType: 'code',
    state: '92b7d6c791e3431f973aebb31f39a31e',
    codeVerifier: '1qaz2wsx3edc4rfv5tgb6yhn1234567890qwertyuiop'
  },

  firebaseConfig: {
    apiKey: 'AIzaSyDnOuDShmKh3uSiQvf9hGEzvr4bGLry3x4',
    authDomain: 'safe-check-in.firebaseapp.com',
    databaseUrl: 'https://safe-check-in.firebaseio.com',
    projectId: 'safe-check-in',
    storageBucket: 'safe-check-in.appspot.com',
    messagingSenderId: '978625962123',
    appId: '1:978625962123:web:16d1e1811f1a3f23f2748e',
    // web pushes
    vapidKey: 'BCP0zP47Xk05jLu_Abg5ZPGIo7FZOhbKLLcMsaj3pOjx1dxKxZIjzp_tvfFfHWJaiHEozwm14FUO2_Aj17_cR40'
  },
  maximumAllowedFcmPhoneVerifications: 10000,
  isSandBox: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error'; // Included with Angular CLI.
